const $inject = ['$rootScope', '$q', '$http', '$httpParamSerializer'];

const microApiService = function ($rootScope, $q, $http, $httpParamSerializer) {
  const service = {
    get
  };

  function refreshToken(params) {
    console.log('refreshToken');
    $http({
      method: 'POST',
      url: 'https://travelctm-au-development.au.auth0.com/oauth/token',
      headers: {
        'Content-Type': 'application/json'
      },
      data: {
        grant_type: 'client_credentials',
        client_id: 'ubScpD9HcbGzuV2HhUX98G7LZlCTeak6',
        client_secret: 'jXZsSsXQyMta5Dm-KAB-XvGSy1MrEptu1YfnIV8ufSfElBIjyyLX4DZKG3I_koI7',
        audience: 'http://debtor'
      }
    }).then(response => {
      sessionStorage.setItem('microServiceToken', response.data.access_token);
      get(params);
    });
  }

  function get(params) {
    $rootScope.$broadcast('lbaLoader:loaderState', {state: true});
    const microServiceToken = sessionStorage.getItem('microServiceToken');

    if (!microServiceToken)
      refreshToken(params);

    $http({
      method: 'GET',
      url: `https://debtor-dev.ctmdevelopment.com/v1/${params.endpoint}`,
      headers: {
        'Authorization': `Bearer ${microServiceToken}`,
        'Content-Type': 'application/json'
      }
    }).then(response => {
      $rootScope.$broadcast('lbaLoader:loaderState', {state: false});
      $rootScope.$broadcast('lbaToast:showToast', { message: 'Data fetched', messageType: 'success' });

      params.cb(response) }, error => {
      if (error.status === 401) {
        refreshToken(params)
      }
      console.log(error)
    });
  }

  return service;
};

microApiService.$inject = $inject;

export default microApiService;



// WEBPACK FOOTER //
// ./src/services/microApiService.js